module.exports = function(str) {
    if(!str) return str;
    return str.replace(/\s+/g, '-');
};
